'use client';

import { useEffect } from 'react';
import ModuleList, {
  Module,
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';

export interface BookingConfirmationProps extends ModuleListProps {
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const BookingConfirmation = ({
  modules,
  personalizationData,
  trackingData,
}: BookingConfirmationProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'booking_confirmation' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ModuleList modules={modules} />
    </div>
  );
};

BookingConfirmation.displayName = 'BookingConfirmation';

export default BookingConfirmation;
